import dayjs from 'dayjs';

import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {BNCourseApiModel} from '../../../../../api/types/bnrks/models';
import type {DateTimeObj} from '../../../../../utils/datetime';
import type {EventContextsMap, EventData} from '../types';

import {datetimeObjToISOString} from '../../../../../utils/datetime';
import {getCourseLabel} from '../../../../../utils/entity/course';

const UNKNOWN_REASON = 'for an unknown reason';

// TODO: Do we need to render the reason in the notification?
export const getRestartReason = (reason: string) => {
  let result = '';

  switch (reason) {
    case 'automatically':
      result = i18n.t('shared:auto_renew');
      break;
    case 'by_client_themselves':
      result = i18n.t('shared:by_client');
      break;
    case 'by_user_request':
      result = i18n.t('shared:by_coach');
      break;
    default:
      break;
  }

  return result.toLowerCase();
};

// B2B
export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, user} = contexts;

  const isIndividual = !!course?.client_id;

  const courseLabel = getCourseLabel(course);

  const currentRestartedOn = (
    (course?.restarted_on as BNCourseApiModel['restarted_on']) || []
  )
    .filter(Boolean)
    .find(item => {
      const restartedOnDate = Object.values(item)[0] as DateTimeObj;

      return dayjs(datetimeObjToISOString(event.created)).isSame(
        dayjs(datetimeObjToISOString(restartedOnDate)),
        'minute',
      );
    });

  let reason = UNKNOWN_REASON;

  if (currentRestartedOn) {
    reason = getRestartReason(Object.keys(currentRestartedOn)[0]!);
  }

  return {
    avatar: course?.program?.avatar,
    avatarPlaceholder: course?.program?.title,
    subAvatar: user?.avatar,
    subAvatarPlaceholder: user?.name,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:course_extended.title.individual')
       * t('notifications:course_extended.title.group')
       */
      i18n.t(
        `notifications:course_extended.title.${
          isIndividual ? 'individual' : 'group'
        }`,
        {
          courseDates: courseLabel ? `(${courseLabel})` : '',
          courseTitle: course?.program?.title,
          reason,
          userName: user?.name,
        },
      ),
  };
};
